import React from 'react';
import { FormattedMessage, MessageDescriptor } from 'react-intl';

import { Bold } from '@styles/generalStyles';
import { checkForEmptyMessageWithParams } from '@utils/text';

import { ICheckoutPageLayoutMessages } from '../model';

export const getFormattedMessages = (
  { callCenterText, callCenterOpenedText, callCenterOpeningHoursText }: ICheckoutPageLayoutMessages,
  phoneNumber: string,
  openingHours: string,
  isCallCenterOpened: boolean,
) => {
  const callCenterNumberMessage = isCallCenterOpened
    ? formatPhoneNumberMessage(callCenterOpenedText, phoneNumber)
    : formatPhoneNumberMessage(callCenterText, phoneNumber);

  const callCenterOpeningHoursMessage = isCallCenterOpened
    ? null
    : formatCallCenterOpeningHours(callCenterOpeningHoursText, openingHours);

  return {
    callCenterNumberMessage,
    callCenterOpeningHoursMessage,
  };
};

const formatPhoneNumberMessage = (message: MessageDescriptor, phoneNumber: string) => (
  <FormattedMessage
    id={message.id}
    values={{
      phoneNumber: <Bold>{phoneNumber}</Bold>,
    }}>
    {(...chunks) => <>{checkForEmptyMessageWithParams(chunks, message, phoneNumber)}</>}
  </FormattedMessage>
);

const formatCallCenterOpeningHours = (message: MessageDescriptor, openingHours: string) => (
  <FormattedMessage
    id={message.id}
    values={{
      openingHours: openingHours,
    }}>
    {(...chunks) => <>{checkForEmptyMessageWithParams(chunks, message, openingHours)}</>}
  </FormattedMessage>
);
